<template>
  <div class="app-container">
    <Header @home="page='home'" @about="page='about'" />
    <IndexPage v-if="page==='home'" />
    <AboutPage v-else />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import IndexPage from './views/index/index.vue'
import AboutPage from './views/about/about.vue'

import { ref } from 'vue'
export default { 
  name: 'App', 
  components: { Header, IndexPage, AboutPage }, 
  setup(){ 
    return { page: ref('home') } 
  } 
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
